import { IPreviewPublicationRequest } from '../../../../model/sdp/official-daily/request/preview-publication-request';
import { IPreviewPublicationResponse } from '../../../../model/sdp/official-daily/response/preview-publication-response';
import { ICategoryPublicationResponse } from '../../../../model/sdp/official-daily/response/category-publication-response';
import { IEntityPublicationResponse } from '../../../../model/sdp/official-daily/response/entity-publication-response';
import { ISubCategoryPublicationResponse } from '../../../../model/sdp/official-daily/response/subcategory-publication-response';
import { IListDocumentTypesResponse } from '../../../../model/sdp/base/list-document-types-response';

export type PublicationLookups = {
  categories: ICategoryPublicationResponse[];
  subcategories: ISubCategoryPublicationResponse[];
  publicAgencies: IEntityPublicationResponse[];
  documentTypes: IListDocumentTypesResponse[];
};

export type OfficialDiaryPublicationState = {
  activeStep: number;
  files: File[];
  previewPublicationRequest: IPreviewPublicationRequest;
  previewPublicationResponse: IPreviewPublicationResponse;
  lookups: PublicationLookups;
  showValidationErrors: boolean;
};

export enum ACTION_TYPES {
  setActiveStep = 'setActiveStep',
  setFiles = 'setFiles',
  updatePreviewPublicationRequest = 'updatePreviewPublicationRequest',
  setPreviewPublicationResponse = 'setPreviewPublicationResponse',
  updateLookups = 'updateLookups',
  setShowValidationErrors = 'setShowValidationErrors',
  resetForm = 'resetForm',
}

export const OfficialDiaryPublicationReducer = (state: OfficialDiaryPublicationState, action: any): OfficialDiaryPublicationState => {
  const { type, payload } = action;
  switch (type) {
    case ACTION_TYPES.setActiveStep:
      return {
        ...state,
        activeStep: payload,
      };
    case ACTION_TYPES.setFiles:
      return {
        ...state,
        files: payload,
      };
    case ACTION_TYPES.updatePreviewPublicationRequest:
      return {
        ...state,
        previewPublicationRequest: {
          ...state.previewPublicationRequest,
          ...payload,
        },
      };
    case ACTION_TYPES.setPreviewPublicationResponse:
      return {
        ...state,
        previewPublicationResponse: payload,
      };
    case ACTION_TYPES.updateLookups:
      return {
        ...state,
        lookups: {
          ...state.lookups,
          ...payload,
        },
      };
    case ACTION_TYPES.setShowValidationErrors:
      return {
        ...state,
        showValidationErrors: payload,
      };
    // Nova publicação mantém entidade, classificação e textos para agilizar publicações em sequência
    case ACTION_TYPES.resetForm:
      return {
        ...state,
        activeStep: 0,
        files: [],
        showValidationErrors: false,
        previewPublicationResponse: {} as IPreviewPublicationResponse,
        previewPublicationRequest: {
          ...state.previewPublicationRequest,
          republication: false,
          publicationDateOn: payload.publicationDateOn,
        },
      };
    default:
      throw new Error(`Unhandled action type: ${type}`);
  }
}
